import React, { useState } from 'react';
import { Users, X, Copy } from 'lucide-react';

const SanghamittaModal = ({ isOpen, onClose, item, showToast }) => {
  const [partyTime, setPartyTime] = useState('');

  if (!isOpen || !item) return null;

  const copyInvitation = () => {
    if (!partyTime) {
      console.warn('Please select a time first.');
      return;
    }
    const date = new Date(partyTime);
    const utcTime = date.getTime();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const baseUrl = window.isNativeApp
      ? 'https://baws.in'
      : window.location.origin;
    const url = `${baseUrl}/listen?item=${encodeURIComponent(
      item.id
    )}&party=${utcTime}`;

    let message = `🎧 Join me for a Listen Together party!

Title: ${item.title}`;

    if (item.description) {
      message += `

${item.description}`;
    }

    message += `

Time: ${date.toLocaleString()} (${timeZone})

Click here to join: ${url}`;

    try {
      navigator.clipboard.writeText(message);
    } catch (e) {
      const textArea = document.createElement('textarea');
      textArea.value = message;
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }
      document.body.removeChild(textArea);
    }

    if (showToast) showToast('Invitation copied to clipboard!');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-2xl p-6 max-w-md w-full shadow-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <Users className="text-blue-500" /> Sanghamitta
          </h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <X size={20} />
          </button>
        </div>

        <p className="text-slate-400 text-sm mb-6">
          Schedule a "Listen Together" session for <strong>{item.title}</strong>
          . Share the link to play this track synchronously with friends.
        </p>

        <div className="mb-6">
          <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
            Start Time (Your Timezone)
          </label>
          <input
            type="datetime-local"
            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500"
            value={partyTime}
            onChange={(e) => setPartyTime(e.target.value)}
          />
        </div>

        <button
          onClick={copyInvitation}
          className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
        >
          <Copy size={18} /> Copy Invitation
        </button>
      </div>
    </div>
  );
};

export default SanghamittaModal;
